import React from "react";
import { ERROR_LOADING_MESSAGES } from "constants/index";
import Error from "components/Error/Error";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  render() {
    if (this.state.errorInfo) {
      return (
        <Error errorMessage={ERROR_LOADING_MESSAGES.CLIENT} isRefresh={true} />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
